/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2DeleteFilled/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2DeleteFilled({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2DeleteFilled",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#000000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2DeleteFilled.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-Z1HCNmk': alignSelf,'--mt-2-Z1HCNmk': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1HCNmk': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1HCNmk': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1HCNmk': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1HCNmk': opacity,'--w-10-Z1HCNmk': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1HCNmk': typeof height === 'number' ? `${height}px` : height,'--f-12-Z1HCNmk': fill,'--a-7-Z1HCNmk': isAnimated ? animation : "none",'--sd-8-Z1HCNmk': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1HCNmk': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="Tysiav2DeleteFilled.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_1685_38316)"
 className="views-block"
>
<path
  data-testid="Tysiav2DeleteFilled.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M4.94 1.725a1.5 1.5 0 012.498.632H4.563a1.5 1.5 0 01.376-.632zm-1.692.632a2.786 2.786 0 015.505 0h2.39a.643.643 0 110 1.286h-.857v7.071A1.286 1.286 0 019 12H3a1.286 1.286 0 01-1.286-1.286V3.643H.857a.643.643 0 110-1.286h2.39zm1.038 2.68c.296 0 .536.24.536.536v3.43a.536.536 0 01-1.072 0v-3.43c0-.296.24-.536.536-.536zm3.964.536a.536.536 0 00-1.071 0v3.43a.536.536 0 001.071 0v-3.43z"
 style={{'--f-12-Z1HCNmk': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}